/**
 * This module manages the orchestration of multiple concurrent document uploads.
 * It implements a worker pool pattern using redux-saga to handle multiple uploads efficiently.
 */

import { all, takeEvery } from "redux-saga/effects";
import { uploadStart } from "./documentUploadsSlice";
import { handleUploadDocument } from "./uploadHandler";

export function* documentUploadsSaga(): Generator {
  yield all([yield takeEvery(uploadStart.type, handleUploadDocument)]);
}
